import { BetonOrderEffects } from './beton-order.effects';

export const effects: any[] = [BetonOrderEffects];
